/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-warning-circle-xl': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" id="svgicon-icon-warning-circle-xl-a" d="M3.375 8.617v2.25h-2.25v-2.25zM.75 1.133l3 .012-.76 5.988H1.51z"/><mask id="svgicon-icon-warning-circle-xl-b" _fill="#fff"><use fill-rule="evenodd" xlink:href="#svgicon-icon-warning-circle-xl-a"/></mask></defs><g _fill="none" fill-rule="evenodd"><circle pid="1" cx="12" cy="12" _fill="#fff" r="12"/><g _fill="#515151" transform="translate(9.75 6)"><use xlink:href="#svgicon-icon-warning-circle-xl-a"/><path pid="2" d="M0 0h4.5v12H0z" mask="url(#svgicon-icon-warning-circle-xl-b)"/></g></g>'
  }
})
